export function getItemImage(
    item: Category|ProductOption,
    defaultImage: string,
    showItemImage: boolean = false
): string | null {
    if (!showItemImage) {
        return null;
    }

    if (item.image_url) {
        return item.image_url;
    }

    return defaultImage;
}
